import React from "react";
import Loader from "./Loader";
import { ReactMarkup } from "../../../globalTypes";

type Config = {
  size?: number;
};

const withLoader = (
  wrappedMarkup: ReactMarkup,
  isLoading: boolean,
  config?: Config
) => {
  if (isLoading) {
    return <Loader {...config} />;
  }

  return wrappedMarkup;
};

export default withLoader;
export type WithLoaderConfig = Config;
